module.exports = require('./lib/static/prefixAll')



//////////////////
// WEBPACK FOOTER
// ./node_modules/aphrodite/node_modules/inline-style-prefixer/static.js
// module id = 1043
// module chunks = 0